/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable import/no-extraneous-dependencies */
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import {
  Button,
  cn,
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui";
import { FaEdit } from "react-icons/fa";
import { MdDeleteSweep } from "react-icons/md";

export default function LocationInitials({
  onNextStep,
  isValid,
  onAddLocations,
  addedLocations = [],
  onPrevStep,
}) {
  const [currentEditing, setCurrentEditing] = useState(null);
  const [locations, setLocations] = useState([]);

  const form = useForm({
    defaultValues: {
      initialType: "",
      initialValue: "",
    },
  });

  const { handleSubmit, control, reset } = form;

  const formValidationRules = {
    initialType: { required: "Please Select Initial Type" },
    initialValue: { required: "Please Enter Initial Value" },
  };

  const submitInfo = (data) => {
    delete data.bagTypes;
    if (currentEditing !== null) {
      const updatedData = locations?.map((_i, index) => {
        if (index === currentEditing) return { ...data };
        return _i;
      });
      onAddLocations(updatedData);
      setLocations(updatedData);
    } else {
      onAddLocations([...locations, { ...data }]);
      setLocations([...locations, { ...data }]);
    }
    reset();
    setCurrentEditing(null);
  };

  function EditCell({ dataItem, dataIndex }) {
    return (
      <td>
        <div
          title="Edit Cassette"
          className="cursor-pointer flex justify-center"
          onClick={() => {
            reset({
              ...dataItem,
            });
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </div>
      </td>
    );
  }

  function DeleteCell({ dataIndex }) {
    return (
      <td>
        <div
          title="Delete Cassette"
          className="cursor-pointer flex justify-center"
          onClick={() => {
            setCurrentEditing(null);
            reset();
            const updateData = locations.filter(
              (_, index) => index !== dataIndex,
            );
            onAddLocations(updateData);
            setLocations(updateData);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </div>
      </td>
    );
  }
  const cancelEditing = () => {
    reset({
      locationName: "",
      locationId: "",
      initialType: "",
      bagTypes: [],
    });
    setCurrentEditing(null);
  };

  useEffect(() => {
    if (!locations?.length && addedLocations?.length) {
      setLocations([...addedLocations]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addedLocations]);

  return (
    <Form {...form}>
      <form onSubmit={handleSubmit(submitInfo)}>
        <div className="flex justify-between w-full">
          <h2 className="font-bold text-2xl">Location Initials</h2>
          <div className="flex gap-4">
            <Button
              type="button"
              variant="secondary"
              onClick={() => onPrevStep()}
            >
              Back
            </Button>
            <Button
              type="submit"
              // disabled={!isValid}
              variant="secondary"
              onClick={() => {
                onNextStep();
              }}
            >
              Next
            </Button>
          </div>
        </div>
        <div className="flex gap-4 w-full">
          <FormField
            isRequired
            control={control}
            name="initialType"
            rules={formValidationRules.initialType}
            render={({ field }) => (
              <FormItem className="max-w-80 w-full">
                <FormLabel>Location Type</FormLabel>
                <Select
                  value={field.value}
                  onValueChange={(val) => field.onChange(val)}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select Location Type" />
                  </SelectTrigger>
                  <SelectContent>
                    {[
                      "ATM Code",
                      "CIT Code",
                      "SCDM Code",
                      "ATM-PNX Code",
                      "CIT-PNX Code",
                    ]?.map((item) => (
                      <SelectItem key={item} value={item}>
                        {item}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>

                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="initialValue"
            rules={formValidationRules.initialValue}
            render={({ field }) => (
              <FormItem className="space-y-2">
                <FormLabel>Initial Value</FormLabel>
                <Input {...field} />
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        {currentEditing !== null ? (
          <Button
            type="button"
            onClick={cancelEditing}
            variant="secondary"
            className="block ml-auto"
          >
            Cancel
          </Button>
        ) : null}
        <Button
          type="submit"
          variant="secondary"
          className={cn(currentEditing !== null ? "" : "block ml-auto")}
        >
          {currentEditing !== null ? "Edits " : "Add"}
        </Button>

        <Grid data={locations} style={{ width: "100%" }}>
          <GridColumn title="Initial Type" field="initialType" />
          <GridColumn title="Initial Value" field="initialValue" />
          <GridColumn title="Edit" width={120} cell={EditCell} />
          <GridColumn title="Delete" width={120} cell={DeleteCell} />
        </Grid>
      </form>
    </Form>
  );
}
